import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'
import { InsightCount } from 'schemas/action/InsightCountSchema'

const DemographicStatusFailGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  if (!widgetData || widgetData.status === 'failed')
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>

  return children
}

export default DemographicStatusFailGuard
